// Ohne Node-Abhängigkeiten: wird vom Worker, von <Picture> und von der Fokus-Vorschau im Browser genutzt.

export const CROPS = {
  orig: { label: "Original", ratio: null },
  "16x9": { label: "16:9", ratio: 16 / 9 },
  "2x3": { label: "2:3 (Pinterest)", ratio: 2 / 3 },
  "1x1": { label: "1:1", ratio: 1 },
} as const;
export type Crop = keyof typeof CROPS;
export const CROP_KEYS = Object.keys(CROPS) as Crop[];

export const WIDTHS = [400, 800, 1200, 1600, 2400] as const;

/** Inhaltsbreite öffentlicher Seiten: 95 % der Kopfzeile (--page in home.module.css). */
export const PAGE_WIDTH = 1216;
export const PAGE_SIZES = `(max-width: 1376px) 95vw, ${PAGE_WIDTH}px`;
export const FORMATS = ["avif", "webp", "jpg"] as const;
export type Format = (typeof FORMATS)[number];

/** Pro Zuschnitt: Maße in voller Auflösung und die tatsächlich erzeugten Breiten. */
export type Variants = Partial<Record<Crop, { width: number; height: number; widths: number[] }>>;

export type MediaForPicture = {
  filename: string;
  version: number;
  width: number;
  height: number;
  alt: string;
  blurDataUrl: string | null;
  variants: string | null;
};

/** Ausschnitt um den Fokuspunkt (0..1), so groß wie möglich und nie über den Bildrand hinaus. */
export function cropRect(width: number, height: number, ratio: number | null, fx: number, fy: number) {
  if (!ratio) return { left: 0, top: 0, width, height };
  let w = width;
  let h = Math.round(width / ratio);
  if (h > height) {
    h = height;
    w = Math.round(height * ratio);
  }
  const clamp = (v: number, max: number) => Math.min(Math.max(Math.round(v), 0), max);
  return { left: clamp(fx * width - w / 2, width - w), top: clamp(fy * height - h / 2, height - h), width: w, height: h };
}

/** Breiten ohne Hochskalieren; ist das Bild schmaler als 400 px, gibt es genau eine Variante in Originalbreite. */
export function widthsFor(width: number) {
  const list: number[] = WIDTHS.filter((w) => w <= width);
  return list.length ? list : [width];
}

export const variantUrl = (m: Pick<MediaForPicture, "filename" | "version">, crop: Crop, width: number, fmt: Format) =>
  `/media/${m.filename}/v${m.version}/${crop}-${width}.${fmt}`;

export function parseVariants(json: string | null): Variants {
  if (!json) return {};
  try {
    return JSON.parse(json) as Variants;
  } catch {
    return {};
  }
}

/** Dateiname für URLs: Kleinbuchstaben, Umlaute ausgeschrieben, sonst nur a-z, 0-9 und Bindestriche. */
export function slugify(input: string, max = 60) {
  const s = input
    .toLowerCase()
    .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
    .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, max)
    .replace(/-+$/g, "");
  return s || "bild";
}
